import axios from 'axios';
import config from './config';

class product {
    constructor() {
        this.url = config.url();
    }

    async list(){
        try{
            var data = { };
            var pkgheaders = { vtoken:sessionStorage.getItem('vtoken'),vkey: sessionStorage.getItem('vkey') };
            var result = await axios.post(this.url + "/api/product/list",data,{ responseType:'json',credentials:false,headers:pkgheaders});
            return (result.status==200) ? result.data : {code:-1,message:''};
        }catch(err){
            return {code:-1,message:err};
        }
    }

    async list_selection(){
        try{
            var data = { };
            var pkgheaders = { vtoken:sessionStorage.getItem('vtoken'),vkey: sessionStorage.getItem('vkey') };
            var result = await axios.post(this.url + "/api/product/list/selection",data,{ responseType:'json',credentials:false,headers:pkgheaders});
            return (result.status==200) ? result.data : {code:-1,message:''};
        }catch(err){
            return {code:-1,message:err};
        }
    }

    async get(id){
        try{
            var data = { id:id };
            var pkgheaders = { vtoken:sessionStorage.getItem('vtoken'),vkey: sessionStorage.getItem('vkey') };
            var result = await axios.post(this.url + "/api/product/get",data,{ responseType:'json',credentials:false,headers:pkgheaders});
            return (result.status==200) ? result.data : {code:-1,message:''};
        }catch(err){
            return {code:-1,message:err};
        }
    }

    async new(){
        try{
            var data = { };
            var pkgheaders = { vtoken:sessionStorage.getItem('vtoken'),vkey: sessionStorage.getItem('vkey') };
            var result = await axios.post(this.url + "/api/product/new",data,{ responseType:'json',credentials:false,headers:pkgheaders});
            return (result.status==200) ? result.data : {code:-1,message:''};
        }catch(err){
            console.log(err);
            return {code:-1,message:err};
        }
    }

    async save(product){
        try{
            var data = product;
            console.log(data);
            var pkgheaders = { vtoken:sessionStorage.getItem('vtoken'),vkey: sessionStorage.getItem('vkey') };
            var result = await axios.post(this.url + "/api/product/save",data,{ responseType:'json',credentials:false,headers:pkgheaders});
            console.log(result);
            return (result.status==200) ? result.data : {code:-1,message:''};
        }catch(err){
            return {code:-1,message:err};
        }
    }

    async delete(list){
        try{
            var data = {list:list};
            var pkgheaders = { vtoken:sessionStorage.getItem('vtoken'),vkey: sessionStorage.getItem('vkey') };
            var result = await axios.post(this.url + "/api/product/delete",data,{ responseType:'json',credentials:false,headers:pkgheaders});
            return (result.status==200) ? result.data : {code:-1,message:''};
        }catch(err){
            return {code:-1,message:err};
        }
    }

    async movement_new(id,date_movement,qty_in,qty_out,label,locality){
        try{
            var data = { id:id,date_movement:date_movement,qty_in:qty_in,qty_out:qty_out,label:label,locality:locality };
            var pkgheaders = { vtoken:sessionStorage.getItem('vtoken'),vkey: sessionStorage.getItem('vkey') };
            var result = await axios.post(this.url + "/api/product/movements/new",data,{ responseType:'json',credentials:false,headers:pkgheaders});
            return (result.status==200) ? result.data : {code:-1,message:''};
        }catch(err){
            console.log(err);
            return {code:-1,message:err};
        }
    }
    
    async file_upload(id,file){
        try{
            var formData = new FormData();
            formData.append('file',file);
            formData.append('id',id);
            var pkgheaders = { vtoken:sessionStorage.getItem('vtoken'),vkey: sessionStorage.getItem('vkey') };
            var result = await axios.post(this.url + "/api/product/files/upload",formData,{ responseType:'json',credentials:false,headers:pkgheaders});
            return (result.status==200) ? result.data : {code:-1,message:''};
        }catch(err){
            return {code:-1,message:err};
        }
    }

    async file_download(id,filename){
        try{
            var data = {id:id,filename:filename}
            var pkgheaders = { vtoken:sessionStorage.getItem('vtoken'),vkey: sessionStorage.getItem('vkey') };
            var result = await axios.post(this.url + "/api/product/files/download",data,{ responseType:'arraybuffer',credentials:false,headers:pkgheaders});
            return (result.status==200) ? result.data : {code:-1,message:''};
        }catch(err){
            return {code:-1,message:err};
        }
    }

    async file_delete(id,filename){
        try{
            var data = {id:id,filename:filename};
            var pkgheaders = { vtoken:sessionStorage.getItem('vtoken'),vkey: sessionStorage.getItem('vkey') };
            var result = await axios.post(this.url + "/api/product/files/delete",data,{ responseType:'json',credentials:false,headers:pkgheaders});
            return (result.status==200) ? result.data : {code:-1,message:''};
        }catch(err){
            return {code:-1,message:err};
        }
    }

    async print(appname,appid){
        try{
            var data = { appname:appname,appid:appid};
            var pkgheaders = { vtoken:sessionStorage.getItem('vtoken'),vkey: sessionStorage.getItem('vkey') };
            var result = await axios.post(this.url + "/api/product/print",data,{ responseType:'arraybuffer',credentials:false,headers:pkgheaders});
            return (result.status==200) ? result.data : {code:-1,message:''};
        }catch(err){
            return {code:-1,message:err};
        }
    }

    async attribute_new(id_product){
        try{
            var data = { id_product:id_product };
            var pkgheaders = { vtoken:sessionStorage.getItem('vtoken'),vkey: sessionStorage.getItem('vkey') };
            var result = await axios.post(this.url + "/api/product/attribute/new",data,{ responseType:'json',credentials:false,headers:pkgheaders});
            return (result.status==200) ? result.data : {code:-1,message:''};
        }catch(err){
            console.log(err);
            return {code:-1,message:err};
        }
    }

    async attribute_save(attribute){
        try{
            var data = attribute;
            console.log(data);
            var pkgheaders = { vtoken:sessionStorage.getItem('vtoken'),vkey: sessionStorage.getItem('vkey') };
            var result = await axios.post(this.url + "/api/product/attribute/save",data,{ responseType:'json',credentials:false,headers:pkgheaders});
            console.log(result);
            return (result.status==200) ? result.data : {code:-1,message:''};
        }catch(err){
            return {code:-1,message:err};
        }
    }

    async attribute_generate(id_product){
        try{
            var data = { id:id_product };
            var pkgheaders = { vtoken:sessionStorage.getItem('vtoken'),vkey: sessionStorage.getItem('vkey') };
            var result = await axios.post(this.url + "/api/product/attribute/generate",data,{ responseType:'json',credentials:false,headers:pkgheaders});
            return (result.status==200) ? result.data : {code:-1,message:''};
        }catch(err){
            console.log(err);
            return {code:-1,message:err};
        }
    }

}

export default new product()